export const fetchPendingInvoices = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { organization, resident } = state

    dispatch({type: 'BEGIN_FETCH_PENDING_INVOICES'})
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/pending_invoices.json`,
      success: (response) => {
        dispatch({type: 'SUCCESS_FETCH_PENDING_INVOICES', payload: response })

      },
      error: () => {
        dispatch({type: 'FAILED_FETCH_PENDING_INVOICES'})

      }
    })
  }
}

export function submitResendInvoiceEmail(invoiceId){
  return (dispatch, getState) => {
    const { organization } = getState()

    dispatch({type:'BEGIN_RESEND_PENDING_INVOICE_EMAIL', payload: invoiceId})
    $.ajax({
      url: `/organizations/${organization.name}/invoices/${invoiceId}/resend_email.json`,
      method: 'PATCH',
      success: () => {
        dispatch({type:'SUCCESS_RESEND_PENDING_INVOICE_EMAIL', payload: invoiceId})
      },
      error: () => {
        dispatch({type:'FAILED_RESEND_PENDING_INVOICE_EMAIL', payload: invoiceId})
      }
    })
  }
}